import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, goBack } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { getBotimClientId } from 'utils'

// ------------------------------------
// Constants
// ------------------------------------
export const OAUTH_BOTIM_LOGIN = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'OAUTH_BOTIM_LOGIN')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        body: {
          hostApp: 'botim-pay',
          redirectUri: window.location.href,
          clientId: getBotimClientId(),
          ...data,
        },
        method: 'POST',
        endpoint: '/cgs/api/personal/auth/loginByAuthCode',
        requestAction: OAUTH_BOTIM_LOGIN.INIT_REQUEST,
        successAction: OAUTH_BOTIM_LOGIN.INIT_SUCCESS,
        success: function(result) {
          console.log(result)
          sessionStorage.setItem('isLogin', true)
          dispatch(goBack())
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [OAUTH_BOTIM_LOGIN.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [OAUTH_BOTIM_LOGIN.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'oauthBotimLogin',
    reducerMap: {
      oauthBotimLoginState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
